import Marquee from "react-fast-marquee";
import { COUNTRIES } from "./data";

const PROMISES = [
  "AI-Free Content",
  "Plagiarism-Free Guarantee",
  "100% Human Writers",
  "On-Time Delivery",
  "Free Originality Report",
  "24/7 Expert Support",
];

const Diamond = () => <span className="mx-8 inline-block h-2 w-2 rotate-45 bg-[#D4AF37]/60" />;

export const EditorialMarquee = () => (
  <section className="border-y border-[#D4AF37]/15 bg-[#F3EEE2] py-7" data-testid="editorial-marquee">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {PROMISES.map((p) => (
        <span key={p} className="flex items-center">
          <span className="font-serif-display text-2xl italic text-[#A07E1F]/90 sm:text-3xl">{p}</span>
          <Diamond />
        </span>
      ))}
    </Marquee>
  </section>
);

export const CountriesStrip = () => (
  <section className="border-b border-[#D4AF37]/10 bg-white py-5" data-testid="countries-strip">
    <p className="mb-4 text-center font-mono-accent text-[10px] uppercase tracking-[0.35em] text-[#75849B]">
      Serving students in 15+ countries
    </p>
    <Marquee speed={24} gradient={false} direction="right" pauseOnHover>
      {COUNTRIES.map((c) => (
        <span key={c} className="mx-6 font-mono-accent text-xs uppercase tracking-[0.25em] text-[#5E6E85]">
          {c}
          <span className="ml-12 text-[#A07E1F]/50">·</span>
        </span>
      ))}
    </Marquee>
  </section>
);
